// Lightweight email typo suggestion (mailcheck-style, no deps). Catches common
// domain misspellings (gmial.com → gmail.com) and TLD slips (.con → .com).
// Suggestion only — nothing here ever rejects an address.

const DOMAINS = [
  'gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.gr', 'hotmail.co.uk',
  'outlook.com', 'outlook.com.gr', 'outlook.gr', 'live.com', 'msn.com',
  'yahoo.com', 'yahoo.gr', 'yahoo.co.uk', 'ymail.com', 'rocketmail.com',
  'icloud.com', 'me.com', 'mac.com', 'aol.com',
  'proton.me', 'protonmail.com', 'gmx.com', 'gmx.net', 'yandex.com', 'mail.com',
  'otenet.gr', 'forthnet.gr', 'hol.gr', 'freemail.gr', 'windowslive.com',
];
const TLDS = ['com', 'gr', 'net', 'org', 'com.gr', 'edu.gr', 'co.uk', 'io', 'me', 'info', 'eu'];

function editDistance(a, b) {
  const m = a.length, n = b.length;
  const d = Array.from({ length: m + 1 }, (_, i) => { const row = new Array(n + 1).fill(0); row[0] = i; return row; });
  for (let j = 0; j <= n; j++) d[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
    }
  }
  return d[m][n];
}

function closest(token, list, maxDist) {
  let best = null; let bd = maxDist + 1;
  for (const c of list) {
    if (c === token) return null; // exact — nothing to suggest
    const dist = editDistance(token, c);
    if (dist < bd) { bd = dist; best = c; }
  }
  return bd <= maxDist ? best : null;
}

// Returns a suggested corrected email, or '' if the address looks fine / unknown.
export function suggestEmail(email) {
  const e = (email || '').trim().toLowerCase();
  const at = e.indexOf('@');
  if (at < 1 || e.indexOf(' ') !== -1) return '';
  const local = e.slice(0, at);
  const domain = e.slice(at + 1);
  if (!domain || domain.indexOf('.') < 1) return '';

  // Short domains are one edit away from too many legitimate ones (in.gr vs
  // ing.gr) — only suggest on a single slip there.
  const dsug = closest(domain, DOMAINS, domain.length <= 8 ? 1 : 2);
  if (dsug && dsug !== domain) return local + '@' + dsug;

  const dot = domain.lastIndexOf('.');
  const host = domain.slice(0, dot);
  const tld = domain.slice(dot + 1);
  const tsug = closest(tld, TLDS, 1);
  if (tsug && tsug !== tld) return local + '@' + host + '.' + tsug;

  return '';
}
